import { Fragment, FunctionComponent, MutableRefObject } from 'react';
import { createPortal } from 'react-dom';
import { t } from '@/utils/i18n';
import { isSmartomat } from '@/utils/params';

interface MobileMacroViewTitleProps {
  container?: MutableRefObject<HTMLElement | null>;
}

const MobileMacroViewTitle: FunctionComponent<MobileMacroViewTitleProps> = ({ container }) => {
  if (isSmartomat() && container?.current) {
    return createPortal(
      <h3 className="draft-viewer__info">{t('draft.nav.view.material')}</h3>,
      container.current
    );
  }

  return null;
};

interface MacroViewProps {
  imageUrl: string;
  width: number;
  height: number;
  container?: MutableRefObject<HTMLElement | null>;
}

export const MacroView: FunctionComponent<MacroViewProps> = ({
  imageUrl,
  width,
  height,
  container,
}) => (
  <Fragment>
    <clipPath id="circle-mask">
      <circle cx={width / 2} cy={height / 2} r={width / 2 - 0.15 * (width / 2)} />
    </clipPath>
    <image
      key={imageUrl}
      xlinkHref={imageUrl}
      width={width}
      height={height}
      clipPath="url(#circle-mask)"
    />
    <MobileMacroViewTitle container={container} />
  </Fragment>
);
